export const routes = {
  LOGIN: "/login",
  ADMIN_DASHBOARD: "/admin",
  PATIENT_LIST: "/admin/patients",
  PATIENT_DETAILS: "/admin/patients/:id",
  CONSULTANT_LIST: "/admin/consultants",
  CONSULTANT_DETAILS: "/admin/consultants/:id",
  CONSULTATIONS_LIST: "/admin/consultations",
  METRICS_DASHBOARD: "/admin/metrics",
  PLAN_LIST: "/admin/plans",
  COUPON_LIST: "/admin/coupons",
  COUNTRY_LIST: "/admin/countries",
  SUBSCRIPTIONS: "/admin/subscriptions",
  SUBSCRIPTION_DETAILS: (subscriptionId: string) => `/admin/subscriptions/${subscriptionId}`,
  SUBSCRIPTION_DETAILS_PATH: "/admin/subscriptions/:subscriptionId",
  SUBSCRIPTION_CUSTOM_FEATURES: (subscriptionId: string, consultantId: string) =>
    `/admin/subscriptions/${subscriptionId}/custom-features/${consultantId}`,
  SUBSCRIPTION_CUSTOM_FEATURES_PATH:
    "/admin/subscriptions/:subscriptionId/custom-features/:consultantId",
  SUBSCRIPTION_CUSTOM_PLAN: (subscriptionId: string, consultantId: string) =>
    `/admin/subscriptions/${subscriptionId}/custom-plan/${consultantId}`,
  SUBSCRIPTION_CUSTOM_PLAN_PATH:
    "/admin/subscriptions/:subscriptionId/custom-plan/:consultantId",
  PLAN_CREATE: "/admin/plans/new",
  PLAN_EDIT: (id: string) => `/admin/plans/${id}/edit`,
  PLAN_EDIT_PATH: "/admin/plans/:id/edit",
  PLAN_REQUESTS: "/admin/plan-requests",
  BILLING_SIMULATION: "/admin/billing-simulation",
  CONTACT_MESSAGES: "/admin/contact-messages",
  //forgot password
  FORGOT_PASSWORD: "/forgot-password",
  CONFIRM_OTP: "/confirm-otp",
  CREATE_NEW_PASSWORD: "create-new-password",
  NOT_FOUND: "*",
};
  
